import { r2Fetch } from './client';
import { R2FileMoveResponse } from '../types';

export interface R2FileMoveParams {
  bucket_id: string;
  from_key: string;
  to_key: string;
  if_match?: string;
}

export async function r2FileMove(
  params: R2FileMoveParams
): Promise<R2FileMoveResponse> {
  return r2Fetch<R2FileMoveResponse>('/rpc/r2_file_move', {
    body: params,
  });
}
